import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { getFoodPartnersState } from '../../../features/food_partner/get_food_partners';
import { DeleteButton } from '../../common/button';
import { GET_ROUTE_FOOD_PARTNER_FORMS } from '../../../core/constants';
import { ApiRequestStatusEnum } from '../../../core/enums/common/api';
import useNotification from '../../../core/hooks/use_notification';
import { deleteFoodPartnerAction, deleteFoodPartnerState } from '../../../features/food_partner/delete_food_partner';
import { deleteFoodPartnerNotificationData } from '../../../core/utils/notification_utils';

const FoodPartnersList = ({ refreshList }) => {
    const { showNotification } = useNotification();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getFoodPartners = useSelector(getFoodPartnersState);
    const deleteFoodPartner = useSelector(deleteFoodPartnerState);

    const onDeleteFoodPartner = (foodPartnerId) => {
        dispatch(deleteFoodPartnerAction(foodPartnerId))
            .then(response => {
                showNotification(deleteFoodPartnerNotificationData(response));
                response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED && refreshList();
            });
    }

    return (
        <TableContainer component={ Paper } variant="outlined">
            <Table stickyHeader>
                <TableHead>
                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                        <TableCell>Nazwa</TableCell>
                        <TableCell>Nazwa skrócona</TableCell>
                        <TableCell>NIP</TableCell>
                        <TableCell align="center" sx={ { width: 120 } }></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        getFoodPartners?.data?.content?.map(foodPartner => (
                            <TableRow key={ foodPartner?.id } hover>
                                <TableCell sx={ { fontWeight: 500 } }>{ foodPartner?.name }</TableCell>
                                <TableCell>{ foodPartner?.shortName }</TableCell>
                                <TableCell>{ foodPartner?.nip }</TableCell>
                                <TableCell align="center">
                                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={ 1 }>
                                        <Tooltip title="Edytuj dostawcę">
                                            <IconButton
                                                color="primary"
                                                size="small"
                                                onClick={ () => navigate(GET_ROUTE_FOOD_PARTNER_FORMS(foodPartner?.id)) }
                                            >
                                                <EditIcon fontSize="small"/>
                                            </IconButton>
                                        </Tooltip>
                                        <DeleteButton
                                            onDeleteClick={ () => onDeleteFoodPartner(foodPartner?.id) }
                                            isLoading={ deleteFoodPartner?.loading }
                                        />
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))
                    }

                    { (!getFoodPartners?.data?.content || getFoodPartners?.data?.content.length === 0) && (
                        <TableRow>
                            <TableCell colSpan={ 4 } align="center" sx={ { py: 4, color: 'text.secondary' } }>
                                Brak wyników do wyświetlenia.
                            </TableCell>
                        </TableRow>
                    ) }
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default FoodPartnersList;